import { combineReducers } from 'redux';
import categoriesReducer from './categories';
import authReducer from './auth';
import userReducer from './user';
import homeReducer from './home';
import bundlesReducer from './bundles';
import templatesReducer from './templates';
import orderReducer from './order';
import statusReducer from './status';
import ssoAppReducer from './sso-app';

export default combineReducers({
  auth: authReducer,
  user: userReducer,
  categories: categoriesReducer,
  home: homeReducer,
  bundles: bundlesReducer,
  templates: templatesReducer,
  order: orderReducer,
  status: statusReducer,
  ssoApp: ssoAppReducer
});
